export const CUSTOM_IMAGES_CONFIG = [
    {
        groupCodes: ["BMWA"],
        captionedPhoto: {
            description: "Single image in Cargo Area of:",
            items: [
                "Books",
                "Keys",
                "Tablets",
                "Remotes"
            ]
        },
        additionalPhotos: []
    },
    {
        groupCodes: [
            "BMW",
            "BMWN"
        ],
        captionedPhoto: {
            description: "Single image near Gear Shift of:",
            items: [
                "Books",
                "Keys",
                "Tablets",
                "Remotes"
            ]
        },
        additionalPhotos: []
    },
    {
        groupCodes: [
            "GM",
            "GMLS",
            "GMEZ",
            "GMHZ",
            "GMVX",
            "GMD2",
            "AMER"
        ],
        captionedPhoto: {
            description: "",
            items: []
        },
        additionalPhotos: [
            "Keys",
            "Roof",
            "Charging Port (if applicable)"
        ]
    },
    {
        groupCodes: [
            "AHFC",
            "HON",
            "HONM"
        ],
        captionedPhoto: {
            description: "",
            items: []
        },
        additionalPhotos: [
            "Oil Cap",
            "Fill Tube"
        ]
    },
    {
        groupCodes: ["RMAK"],
        captionedPhoto: {
            description: "Public VIN",
            items: []
        },
        additionalPhotos: []
    },
    {
        groupCodes: [
            "MBF",
            "MBFS",
            "MBC",
            "MBNA"
        ],
        captionedPhoto: {
            description: "Single image in Cargo Area of:",
            items: [
                "Books"
            ]
        },
        additionalPhotos: [
            "Oil Cap",
            "Fill Tube"
        ]
    },
    {
        groupCodes: [
            "NIS",
            "NOL",
            "NMAC",
            "INF",
            "NRD"
        ],
        captionedPhoto: {
            description: "Image on Roof near WO# Sticker of:",
            items: [
                "Keys"
            ]
        },
        additionalPhotos: [
            "Oil Cap",
            "Fill Tube"
        ]
    },
    {
        groupCodes: [
            "CHS",
            "MAZD",
            "JAGU",
            "LNDR"
        ],
        make: "RIVIAN",
        captionedPhoto: {
            description: "Center Dash Screen showing vehicle specs",
            items: []
        },
        additionalPhotos: [
            "Center Dash Screen showing battery size"
        ]
    }
]